import { TextFieldProps } from '@material-ui/core'
import { ValueLabelProps } from 'components/Common/ValueLabel/ValueLabel'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { saveBomItemName } from '../store/asyncActions/saveBomItemName'
import { ProjectTextField } from '../store/components/ProjectTextField'
import { ValueLabelConnected } from '../store/components/ValueLabelConnected'
import { bomItemNameSelector } from '../store/selectors/bomItemNameSelector'
import { ProjectEditableStateSelector } from '../store/selectors/ProjectEditableStateSelector'

export function BomItemName(props: {
  bomItemId: string
  textFieldProps?: TextFieldProps
  label?: boolean
  valueLabelProps?: Partial<ValueLabelProps>
}) {
  const { t } = useTranslation()

  const projectIsEditable = useAppSelector(ProjectEditableStateSelector)

  if (!projectIsEditable || props.label) {
    return (
      <ValueLabelConnected
        propertySelector={bomItemNameSelector(props.bomItemId)}
        valueLabelProps={{
          label: t('common:name'),
          valueProps: {
            className: props.textFieldProps?.className,
          },
          isLeftAligned: true,
          fullWidth: true,
          ...props.valueLabelProps,
        }}
      />
    )
  }

  return (
    <ProjectTextField
      valueSelector={bomItemNameSelector(props.bomItemId)}
      actionTypePrefix={saveBomItemName.typePrefix.concat('/', props.bomItemId)}
      saveAction={(value) =>
        saveBomItemName({
          bomItemId: props.bomItemId,
          name: value,
        })
      }
      textFieldProps={{
        label: t('common:name'),
        required: true,
        type: 'text',
        ...props.textFieldProps,
      }}
    />
  )
}
